import { Component, Injector } from '@angular/core';

import { DialogAbstractComponent } from '../dialog.class';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent extends DialogAbstractComponent {
  constructor(injector: Injector) {
    super(injector);
  }
}
